import SlideSet from '@polleverywhere/slide-set'

export default function totalSlideCount (activities) {
  if (!activities || activities.length === 0) {
    return 0
  }

  return (new SlideSet(activities)).slideData.length
}
